import { c as _c } from "react/compiler-runtime";
import { InputBase, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { EditButton } from '@/components/form/baseInputs/Button/EditButton';
import { COLORS } from '@/styles/tokens/colors';
interface InlineTitleEditorProps {
  id: string;
  ariaLabel: string;
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
}

/** A section heading that becomes a same-size input when an author edits it. */
export function InlineTitleEditor(t0) {
  const $ = _c(12);
  const {
    id,
    ariaLabel,
    value,
    placeholder,
    onChange
  } = t0;
  const [draftValue, setDraftValue] = useState(null);
  const isEditing = draftValue !== null;
  let t1;
  if ($[0] !== draftValue || $[1] !== onChange || $[2] !== value) {
    t1 = () => {
      if (draftValue !== null && draftValue !== value) {
        onChange(draftValue);
      }
      setDraftValue(null);
    };
    $[0] = draftValue;
    $[1] = onChange;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const commit = t1;
  let t2;
  if ($[4] !== ariaLabel || $[5] !== commit || $[6] !== draftValue || $[7] !== id || $[8] !== isEditing || $[9] !== placeholder || $[10] !== value) {
    t2 = <Stack direction="row" alignItems="center" flex={1} minWidth={0} ml={-1}>{isEditing ? <InputBase id={id} inputProps={{
        "aria-label": ariaLabel
      }} value={draftValue} placeholder={placeholder} autoFocus={true} fullWidth={true} onFocus={_temp} onChange={event_0 => setDraftValue(event_0.target.value)} onBlur={commit} onKeyDown={event_1 => {
        if (event_1.key === "Enter") {
          event_1.preventDefault();
          commit();
        } else {
          if (event_1.key === "Escape") {
            event_1.preventDefault();
            setDraftValue(null);
          }
        }
      }} sx={_temp2} /> : <><Typography variant="title-m" component="button" type="button" noWrap={true} title="Click to edit" onClick={() => setDraftValue(value)} sx={{
          appearance: "none",
          background: "none",
          margin: 0,
          textAlign: "left",
          cursor: "text",
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          px: 1,
          py: 0.25,
          border: "1px solid transparent",
          color: value ? COLORS.TEXT.PRIMARY : COLORS.TEXT.SECONDARY
        }}>{value || placeholder}</Typography><EditButton aria-label={`Edit ${ariaLabel.toLowerCase()}`} onClick={() => setDraftValue(value)} /></>}</Stack>;
    $[4] = ariaLabel;
    $[5] = commit;
    $[6] = draftValue;
    $[7] = id;
    $[8] = isEditing;
    $[9] = placeholder;
    $[10] = value;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}
function _temp2(theme) {
  return {
    ...theme.typography["title-m"],
    px: 1,
    py: 0.25,
    border: `1px solid ${COLORS.BLUE[500]}`,
    borderRadius: 1,
    bgcolor: COLORS.PRIMITIVES.WHITE,
    "& .MuiInputBase-input": {
      p: 0,
      height: "auto"
    }
  };
}
function _temp(event) {
  return event.target.select();
}